import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { bindActionCreators } from 'redux';
import HomeLayout from '../components/Home';
import {
  TitleEN,
  TitleES,
  menuOptsEN,
  menuOptsES,
  languagesOpts
} from '../utils/header';
import { aboutMeEN, aboutMeES, aboutMeIcons } from '../utils/about-me';
import {
  startupsEN,
  startupsES,
  workTitleEN,
  workTitleES
} from '../utils/workExperience';
import {
  projects,
  projectsTitleEN,
  projectsTitleES
} from '../utils/personalProjects';
import { socialIcons, socialEN, socialES } from '../utils/contact-me';

class Home extends Component {
  state = {
    knowingMe: false,
    expandedMenu: false
  }

  onHandleLanguages = value => {
    const { changeLanguages } = this.props.actions;
    
    changeLanguages(value);
  }

  onHandleKnowingMe = () => {
    this.setState(prevState => ({ knowingMe: !prevState.knowingMe }));
  }

  onHandleExpandedMenu = () => {
    this.setState(prevState => ({ expandedMenu: !prevState.expandedMenu }));
  }
  
  render() {
    const { knowingMe, expandedMenu } = this.state;
    const { language } = this.props;
    const english = language === 'EN';
    let title, menuOpts, aboutMe, workTitle, startups, projectsTitle, social;

    if (english) {
      title = TitleEN;
      menuOpts = menuOptsEN;
      aboutMe = aboutMeEN;
      workTitle = workTitleEN;
      startups = startupsEN;
      projectsTitle = projectsTitleEN;
      social = socialEN;
    } else {
      title = TitleES;
      menuOpts = menuOptsES;
      aboutMe = aboutMeES;
      workTitle = workTitleES;
      startups = startupsES;
      projectsTitle = projectsTitleES;
      social = socialES;
    }

    return (
      <HomeLayout
        title={title}
        menuOpts={menuOpts}
        expandedMenu={expandedMenu}
        handleExpandedMenu={this.onHandleExpandedMenu}
        handleLanguages={this.onHandleLanguages}
        languagesOpts={languagesOpts}
        aboutMe={aboutMe}
        aboutMeIcons={aboutMeIcons}
        handleKnowingMe={this.onHandleKnowingMe}
        knowingMe={knowingMe}
        workTitle={workTitle}
        startups={startups}
        projectsTitle={projectsTitle}
        projects={projects}
        social={social}
        socialIcons={socialIcons}
      />
    );
  }
}

Home.propTypes = {
  changeLanguages: PropTypes.func,
  language: PropTypes.string,
  actions: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

const mapStateToProps = ({ language }) => ({
  language
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
